import { Component, OnInit, ViewContainerRef } from '@angular/core';

import { AuthService, LoginInfo } from '../_services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from '../_services/dialog.service';
import { JwtClaims, JWTTokenService } from '../_services/jwtToken.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseService } from '../_shared/base.service';
import { VendorService } from '../_services/fundraising/vendor.service';
import { OperatorService } from '../_services/fundraising/operator.service';

enum LoginMode {
  Portal = 'portal',
  Onboarding = 'onboarding',
  OperatorOnboarding = 'operatorOnboarding',
  StripeSuccess = 'stripeSuccess',
  StripeFailure = 'stripeFailure',
  ResetPassword = 'resetPassword',
  ForgotPassword = 'forgotPassword',
  VendorUserOnboarding = 'vendorUserOnboarding'
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})



export class LoginComponent implements OnInit {

  public portalRegisterForm: FormGroup;
  public portalLoginForm: FormGroup;
  public forgotPasswordForm: FormGroup;
  public passwordValid = true;
  public forgotPasswordSubmitted = false;

  public get loginModeType(): typeof LoginMode {
    return LoginMode; 
  }

  constructor(
    private authService: AuthService,
    private vendorService: VendorService,
    private operatorService: OperatorService,
    private router: Router,
    private route: ActivatedRoute,
    private viewRef: ViewContainerRef,
    private spinner: NgxSpinnerService,
    private dialogService: DialogService,
    private jwtTokenService: JWTTokenService,
    private fb: FormBuilder) { }

  public loading: Boolean = false;

  public loginMode = LoginMode.Portal;

  ngOnInit() {

    

    this.route.queryParams
    .subscribe(params => {
      const onboardingToken = params['t'];
      const stripeReturnStatus = params['s'];
      const forgotPasswordToken = params['f'];
      const stripeReturnToken = params['p'];
      const operatorOnboardingToken = params['o'];
      const vendorUserOnboardingToken = params['u'];


      if (onboardingToken) {

        this.jwtTokenService.setToken('onboarding', onboardingToken);

        const decodedToken = this.jwtTokenService.decodeToken('onboarding') as JwtClaims;

        if (!this.jwtTokenService.isTokenExpired('onboarding') && decodedToken) {

          if (decodedToken.role.includes('Onboarding') && decodedToken.role.includes('Vendor')) { 

            this.loginMode = LoginMode.Onboarding;

            this.portalRegisterForm = this.fb.group({
              email: ['', [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
              newPassword1: ['',  [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#.?&])[A-Za-z\d@$!.^%*#?&]{8,24}$/)]],
              newPassword2: ['', Validators.required]
            });

          }
        } 
        
      } else if (operatorOnboardingToken) {

        this.jwtTokenService.setToken('operatorOnboarding', operatorOnboardingToken);

        const decodedToken = this.jwtTokenService.decodeToken('operatorOnboarding') as JwtClaims;

        if (!this.jwtTokenService.isTokenExpired('operatorOnboarding') && decodedToken) {

          if (decodedToken.role.includes('Onboarding') && decodedToken.role.includes('Operator')) { 

            this.loginMode = LoginMode.OperatorOnboarding;

            this.portalRegisterForm = this.fb.group({
              email: ['', [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
              newPassword1: ['',  [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#.?&])[A-Za-z\d@$!.^%*#?&]{8,24}$/)]],
              newPassword2: ['', Validators.required]
            });

          }
        } 
        
      } else if (stripeReturnStatus) {

        if (stripeReturnStatus === 'true') {

          this.loginMode = LoginMode.StripeSuccess;

          if (stripeReturnToken) {
            this.jwtTokenService.setToken('stripe-onboarding', stripeReturnToken);
            this.authService.activateVendorAccount().subscribe();
          }

        } else {
          this.loginMode = LoginMode.StripeFailure;
        }

      } else if (forgotPasswordToken) {

        this.jwtTokenService.setToken('forgotPassword', forgotPasswordToken);

        const decodedToken = this.jwtTokenService.decodeToken('forgotPassword') as JwtClaims;

        if (!this.jwtTokenService.isTokenExpired('forgotPassword') && decodedToken) {

          if (decodedToken.role.includes('ForgotPassword') && decodedToken.role.includes('Portal')) { 

            this.loginMode = LoginMode.ResetPassword;

            this.portalRegisterForm = this.fb.group({
              email: ['', [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
              newPassword1: ['',  [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#.?&])[A-Za-z\d@$!.^%*#?&]{8,24}$/)]],
              newPassword2: ['', Validators.required]
            });

          }
        }

      } else if (vendorUserOnboardingToken) {

        this.jwtTokenService.setToken('vendorUserOnboarding', vendorUserOnboardingToken);

        const decodedToken = this.jwtTokenService.decodeToken('vendorUserOnboarding') as JwtClaims;

        if (!this.jwtTokenService.isTokenExpired('vendorUserOnboarding') && decodedToken) {

          if (decodedToken.role.includes('Onboarding') && decodedToken.role.includes('VendorUser')) { 

            this.loginMode = LoginMode.VendorUserOnboarding;

            this.portalRegisterForm = this.fb.group({
              email: ['', [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
              newPassword1: ['',  [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#.?&])[A-Za-z\d@$!.^%*#?&]{8,24}$/)]],
              newPassword2: ['', Validators.required]
            });

          }
        } 

      } else {
        
        this.authService.loggedIn().subscribe(
          result => {
            if (result) {
              this.router.navigate(['/portal/' + this.authService.getHomeRoute()]);
            } else {
              const portalType = localStorage.getItem('portal-type');
              if (portalType === 'merchant') {
                this.router.navigate(['/merchant-login']);
              }
            }
          }
        );

        this.portalLoginForm= this.fb.group({
          email: ['', [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
          password: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#.?&])[A-Za-z\d@$!.^%*#?&]{8,24}$/)]]
        });

        this.forgotPasswordForm = this.fb.group({
          email: ['', [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
        });

        this.loginMode = LoginMode.Portal;

      }
 
      this.spinner.hide();

    });


  }

  merchantNav() {
    localStorage.setItem('portal-type', 'merchant');
    this.router.navigate(['/merchant-login']);
  }

  portalNav() {
    localStorage.setItem('portal-type', 'default');
    this.loginMode = LoginMode.Portal;
    this.router.navigate(['/login']);
  }

  forgotPassword() { 
    this.spinner.show(); 
    this.authService.forgotPassword(this.forgotPasswordForm.controls.email.value.replace(/\s/g, ""))
      .subscribe(() => { 
        this.forgotPasswordSubmitted = true;
        this.spinner.hide();
      });
  }

  resetPassword() { 
    this.spinner.show(); 
    this.authService.resetPassword(
      this.portalRegisterForm.controls.email.value.replace(/\s/g, ""), 
      this.portalRegisterForm.controls.newPassword1.value)
        .subscribe(
          () => { 
          this.dialogService.alert(
            'Password Reset Successful', 
            'You can now login with your new password', 
            this.viewRef)
            .then(() => {
              this.portalNav();
            });
          this.spinner.hide();
        },
          error => {
            this.spinner.hide();
            this.dialogService.alert('Something isn\'t right here...', error.error, this.viewRef)
              .then(() => {
                this.portalNav();
              });
        });
  }

  submitPortalRegistration() {
    if (!this.portalRegisterForm.valid || this.portalRegisterForm.controls.newPassword1.value != this.portalRegisterForm.controls.newPassword2.value) {
      return;
    }

    this.spinner.show();
    this.vendorService.register(this.portalRegisterForm.controls.email.value.replace(/\s/g, ""), this.portalRegisterForm.controls.newPassword1.value)
      .subscribe(
        result => {
          this.spinner.hide();
          if (result) {
            this.dialogService.alert(
              'Account Registered!', 
              'You will be now be redirected to Stripe.com to securely complete your account profile', 
              this.viewRef)
            .then(() => {
              window.location.href = result.stripeOnboardingUrl;
            });
          }
        },
        error => {
          this.spinner.hide();
          this.dialogService.alert('Something isn\'t right here...', error.error, this.viewRef)
            .then(() => {
              this.portalNav();
            });
        }
      );
  }

  submitVendorUserRegistration() {
    if (!this.portalRegisterForm.valid || this.portalRegisterForm.controls.newPassword1.value != this.portalRegisterForm.controls.newPassword2.value) {
      return;
    }

    this.spinner.show();
    this.vendorService.registerVendorUser(this.portalRegisterForm.controls.email.value.replace(/\s/g, ""), this.portalRegisterForm.controls.newPassword1.value)
      .subscribe(
        _ => {
          this.spinner.hide();
          this.dialogService.alert(
            'Account Registered!', 
            'You will be now be redirected to our login page.', 
            this.viewRef)
          .then(() => {
            this.portalNav();
          });
        },
        error => {
          this.spinner.hide();
          this.dialogService.alert('Something isn\'t right here...', error.error, this.viewRef)
            .then(() => {
              this.portalNav();
            });
        }
      );
  }

  submitOperatorRegistration() {
    if (!this.portalRegisterForm.valid || this.portalRegisterForm.controls.newPassword1.value != this.portalRegisterForm.controls.newPassword2.value) {
      return;
    }

    this.spinner.show();

    this.operatorService.register(this.portalRegisterForm.controls.email.value.replace(/\s/g, ""), this.portalRegisterForm.controls.newPassword1.value)
      .subscribe(
        result => {
          this.spinner.hide();
            this.dialogService.alert(
              'Account Registered!', 
              'Thank you for registering your username and password! You\'re all set! Please contact your event organizer if you have any questions.', 
              this.viewRef)
            .then(() => {
              this.portalNav();
            });
        },
        error => {
          this.spinner.hide();
          this.dialogService.alert('Something isn\'t right here...', error.error, this.viewRef)
            .then(() => {
              this.portalNav();
            });
        }
      );
  }
  

  login() {
    this.loading = true;
    this.spinner.show();
    this.authService.login(
      this.portalLoginForm.controls.email.value.replace(/\s/g, ""),
      this.portalLoginForm.controls.password.value)
      .subscribe(response => {
        if (response.stripeOnboardingUrl) {
          this.spinner.hide();
          this.dialogService.alert(
            'Please Complete Your Account Registration',
            'It looks like you haven\'t completed your Fundraising Account registration yet. You will now be redirected to Stripe.com to securely complete your account profile',
            this.viewRef)
            .then(() => {
                window.location.href = response.stripeOnboardingUrl;
            });
          } else if (response.portalToken) {

            // clear all cache when logged in
            BaseService.GlobalClearCache();
  
            const clientAppVersion = localStorage.getItem('Application-Version');
            const serverAppVersion = response.applicationVersion;
            if (serverAppVersion && clientAppVersion !== serverAppVersion) {
              localStorage.setItem('Application-Version', serverAppVersion);
              location.reload();
            }
            this.router.navigate(['/portal/' + this.authService.getHomeRoute()]);
          }
    }, error => {
        switch (error.status) {
          case 403:
            this.dialogService.alert(
              'Time to update your password!',
              'In the interest of protecting your CUE account, we require users to occasionally update their passwords. \
                We\'ve sent an email to the address associated with this account containing a link to the password reset page. \
                If you have any questions, please contact us at support@connectwithcue.com. Thank you for helping us keep your account secure!',
              this.viewRef);
          break;
          case 401:
            this.dialogService.alert('Invalid Credentials', 'Wrong username or password', this.viewRef);
          break;
          default:
            this.dialogService.alert("Looks like our servers are down.", "Please try again in a few minutes.", this.viewRef);
          break;
        }
        this.loading = false;
        this.spinner.hide();
      });
  }

}

